import { Stack, Typography } from '@mui/material';
import { FileUpload, RadioButtons } from 'Components';
import { yesNoOptions } from 'Constants';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { WAS_DRIVER_DURING_ACCIDENT_ID } from '../WhatDidDoDuringAccident';

export const LicenseAndInvolved = () => {
  const { index, fieldId } = useContext(IndexContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}.trafficAccidentSection`;

  const [isDrivingLicenseExist, whatHaveYouDoDuringAccidentOptionId] = useWatch(
    {
      name: [
        `${baseName}.isDrivingLicenseExist`,
        `${baseName}.whatHaveYouDoDuringAccidentOptionId`,
      ],
    }
  );

  return (
    <>
      <RadioButtons
        id={dictionary.thirdSectionOtherInvolvedQ}
        name={`${baseName}.anotherVehicleInvolvedAccident` as const}
        options={yesNoOptions}
      />
      {whatHaveYouDoDuringAccidentOptionId == WAS_DRIVER_DURING_ACCIDENT_ID && (
        <>
          <RadioButtons
            id={dictionary.thirdSectionDrivingLicense}
            name={`${baseName}.isDrivingLicenseExist` as const}
            options={yesNoOptions}
          />
          {isDrivingLicenseExist && (
            <Stack gap='7px'>
              <Typography>
                {dictionary.thirdSectionInputDrivingLicense}
              </Typography>
              <FileUpload
                caseDetailsId={fieldId}
                fileLabel={dictionary.thirdSectionFirstFileUploadText}
                fileCategoryId={FileCategories.DrivingLicense}
                ariaLabel={dictionary.thirdSectionFirstFileUploadLabel}
              />
            </Stack>
          )}
        </>
      )}
    </>
  );
};
